import { useEffect } from "react";
import { toast } from "sonner";

const bundle = (html) => (html.match(/\/static\/js\/main\.[\w]+\.js/) || [])[0];

// Avvisa quando è stata pubblicata una nuova versione mentre la pagina era aperta
export const UpdateNotifier = () => {
  useEffect(() => {
    const current = bundle(document.documentElement.innerHTML);
    if (!current) return undefined;
    let shown = false;
    const check = () => fetch("/", { cache: "no-store" }).then((r) => r.text()).then((html) => {
      const latest = bundle(html);
      if (latest && latest !== current && !shown) {
        shown = true;
        toast("Nuova versione disponibile", { description: "Ricarica la pagina per usare le ultime modifiche.", duration: Infinity,
          action: { label: "Ricarica", onClick: () => window.location.reload() } });
      }
    }).catch(() => {});
    const id = setInterval(check, 5 * 60 * 1000);
    const onFocus = () => check();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(id); window.removeEventListener("focus", onFocus); };
  }, []);
  return null;
};
